import SVG from "../../SVG"
export default function Minimize({ isCollapsed, onToggle, alwaysMini }) {
  return (
    <div
      className="p-1"
      onClick={onToggle}
    >
      <SVG
        name={isCollapsed ? "maximize" : "minimize"}
        classname={`w-7 ${alwaysMini ? "cursor-default" : "cursor-pointer"} stroke-zi-blue-dark dark:stroke-white`}
      />
    </div>
  )
}